export const supportedLocales = ['en', 'fr']